// Internal / non-billable categories that appear in the hours data as a
// "Project" but are NOT client projects (we never invoice our own company).
// They are excluded from the client-facing views (treemap, "Metrics by
// client" table and the consultant×client drill-down). Their overhead is
// simply dropped with them — it is not redistributed onto billable clients.
//
// Matching is done on the normalized project name (same normalization the
// calc utils use: uppercase, strip parenthetical suffixes, dashes/underscores
// to spaces, collapse whitespace), so "Non-Billable", "NON_BILLABLE" and
// "Non Billable (BG)" all map to "NON BILLABLE".

const normalizeProject = (s) =>
  String(s ?? "")
    .trim()
    .toUpperCase()
    .replace(/\(.*?\)/g, "")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const NON_CLIENT_PROJECTS = new Set([
  "INTERNAL",
  "NON BILLABLE",
  "NONBILLABLE",
  "VACATION",
  "VACATIONS",
  "HOLIDAY",
  "HOLIDAYS",
  // Chrona's synthetic "Leave" project (approved leave: paid annual / additional
  // / sick / unpaid). Leave hours are never billable to a client.
  "LEAVE",
  "LEAVES",
  "SICK",
  "SICK LEAVE",
  "TRAINING",
  "TRAININGS",
  "ABSENCE",
  "ABSENCES",
  "BENCH",
]);

export function isNonClientProject(project) {
  return NON_CLIENT_PROJECTS.has(normalizeProject(project));
}
